/** API route map: URLS.Controller.Email */
export const Email = {
      SendEmail: 'email',
};
